import { render, staticRenderFns } from "./CmgMakeItAFavoriteCard.vue?vue&type=template&id=31be8302&scoped=true&lang=pug"
import script from "./cmg-make-it-a-favorite-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-make-it-a-favorite-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMakeItAFavoriteCard.vue?vue&type=style&index=0&id=31be8302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be8302",
  null
  
)

export default component.exports